var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more-box"},[_c('button',{staticClass:"btn"},[_vm._v("查看更多")])])}]

export { render, staticRenderFns }